import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isRegenerate", "transparentPhase"];
import { StyleFontBasedBreezeIcon } from './AIBaseLoadingButton';
import { BreezeStarSVG } from './BreezeStarSVG';
import { StyledAITransparentLoadingButtonAnimation } from './styledButtons/AITransparentLoadingButtonAnimation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AITransparentLoadingButton = _ref => {
  let {
      children,
      isRegenerate = true,
      transparentPhase
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(StyledAITransparentLoadingButtonAnimation, {
    isRegenerate: Boolean(isRegenerate),
    children: [/*#__PURE__*/_jsxs("span", {
      className: "ai-icons-transparent",
      children: [/*#__PURE__*/_jsx(StyleFontBasedBreezeIcon, {
        className: `${transparentPhase} ai-refresh-icon-transparent`,
        children: "breezeRegenerate"
      }), /*#__PURE__*/_jsx(BreezeStarSVG, {
        className: `${transparentPhase} ai-loading-icon-transparent`,
        use: uiButtonProps.use,
        isDisabled: uiButtonProps.disabled
      })]
    }), /*#__PURE__*/_jsx("span", {
      className: "ai-loading-children-transparent",
      children: children
    })]
  });
};